export class AdvanceSearchModel {
  discipline: string;
  suffix: string;
  suffixId: number;
  equpType: string;
  equpDescr: string;
  elrRef: string;   
  elrId: number;
  egiId: number;
  latitude: string;
  longitude: string;
  placeId: number;
  placeName: string;
  eqId:number
  eqNo:string;
  postCode: string;
  formToMap?: boolean;
}